package com.essntl.features.proposal.ui.selectservice

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import com.essntl.core.utils.viewmodel.PaginationState
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.area.domain.model.AreaModel
import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.features.proposal.domain.model.ProposalServiceModel
import com.essntl.features.service.domain.model.service.ServiceFilterOptions
import com.essntl.features.service.domain.model.service.ServiceModel
import com.essntl.features.supplier.domain.model.SupplierModel
import com.essntl.features.tag.domain.model.TagModel

data class SelectServiceState(
    val getAllService: PaginationState<ServiceModel> = PaginationState(),
    val filterOptions: ServiceFilterOptions = ServiceFilterOptions(),
    val getAllTag: State<List<TagModel>> = State(),
    val getAllCategory: State<List<CategoryModel>> = State(),
    val getAllArea: State<List<AreaModel>> = State(),
    val getAllSupplier: State<List<SupplierModel>> = State(),
    val selectedProposalService: MutableState<ProposalServiceModel?> = mutableStateOf(null),
    val previewLink: String? = null,
    val getCurrentProfile: State<ProfileModel> = State(),
)